import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

const DivPortal = (props) => {
    const element = useRef(document.createElement("div"));

    useEffect(() => {
        const el = document.getElementById(props.container);
        el.appendChild(element.current);

        return () => {
            // we never change this reference
            // eslint-disable-next-line react-hooks/exhaustive-deps
            el.removeChild(element.current);
        };
        // nodeps: props.container must never change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return ReactDOM.createPortal(props.children, element.current);
};

export default DivPortal;
